export default __webpack_public_path__ + "static/media/one_to_one.f54fee63.svg";